module.exports = __webpack_public_path__ + "img/12.64f68b4.png";